const hook = {
    missing_events: 'You need to provide at least one event.',
    send_test_payload_failed: 'Failed to send test payload: {{message}}',
    endpoint_responded_with_error: 'Endpoint responded with error.',
};
export default Object.freeze(hook);
